// Tracks the websocket connectionIds this browser (across all tabs) believes are active, so the
// single leader tab's access-token refresh can extend all of their ttls in one request. One
// localStorage key per connectionId — rather than a single shared array — so each tab only ever
// writes/removes its own key, and concurrent tabs never race on a read-modify-write of a shared
// value.
const KEY_PREFIX = "marlin-ws-connection-";

export const registerWsConnection = (connectionId: string): void => {
  localStorage.setItem(KEY_PREFIX + connectionId, "1");
};

export const unregisterWsConnection = (connectionId: string): void => {
  localStorage.removeItem(KEY_PREFIX + connectionId);
};

export const listRegisteredWsConnections = (): string[] => {
  const ids: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(KEY_PREFIX)) {
      ids.push(key.slice(KEY_PREFIX.length));
    }
  }
  return ids;
};

export const pruneDeadWsConnections = (deadConnectionIds: string[]): void => {
  deadConnectionIds.forEach(unregisterWsConnection);
};
